"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The base number of milliseconds to use in calculating a suitable cool-down
 * time when a retryable error is encountered.
 */
exports.DEFAULT_RETRY_DELAY_BASE = 100;
/**
 * The maximum amount of time (in milliseconds) that will be used as a delay
 * between retry attempts.
 */
exports.MAXIMUM_RETRY_DELAY = 20 * 1000;
/**
 * HTTP status codes that indicate the operation may be retried.
 */
exports.RETRYABLE_STATUS_CODES = new Set();
[429, 500, 502, 503, 504, 509].forEach(function (code) {
    return exports.RETRYABLE_STATUS_CODES.add(code);
});
/**
 * The retry delay base (in milliseconds) to use when a throttling error is
 * encountered.
 */
exports.THROTTLING_RETRY_DELAY_BASE = 500;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBOzs7R0FHRztBQUNVLFFBQUEsd0JBQXdCLEdBQUcsR0FBRyxDQUFDO0FBRTVDOzs7R0FHRztBQUNVLFFBQUEsbUJBQW1CLEdBQUcsRUFBRSxHQUFHLElBQUksQ0FBQztBQUU3Qzs7R0FFRztBQUNVLFFBQUEsc0JBQXNCLEdBQUcsSUFBSSxHQUFHLEVBQVUsQ0FBQztBQUN4RCxDQUFDLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRyxDQUFDLENBQUMsT0FBTyxDQUFDLFVBQUEsSUFBSTtJQUN6QyxPQUFBLDhCQUFzQixDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUM7QUFBaEMsQ0FBZ0MsQ0FDakMsQ0FBQztBQUVGOzs7R0FHRztBQUNVLFFBQUEsMkJBQTJCLEdBQUcsR0FBRyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBUaGUgYmFzZSBudW1iZXIgb2YgbWlsbGlzZWNvbmRzIHRvIHVzZSBpbiBjYWxjdWxhdGluZyBhIHN1aXRhYmxlIGNvb2wtZG93blxuICogdGltZSB3aGVuIGEgcmV0cnlhYmxlIGVycm9yIGlzIGVuY291bnRlcmVkLlxuICovXG5leHBvcnQgY29uc3QgREVGQVVMVF9SRVRSWV9ERUxBWV9CQVNFID0gMTAwO1xuXG4vKipcbiAqIFRoZSBtYXhpbXVtIGFtb3VudCBvZiB0aW1lIChpbiBtaWxsaXNlY29uZHMpIHRoYXQgd2lsbCBiZSB1c2VkIGFzIGEgZGVsYXlcbiAqIGJldHdlZW4gcmV0cnkgYXR0ZW1wdHMuXG4gKi9cbmV4cG9ydCBjb25zdCBNQVhJTVVNX1JFVFJZX0RFTEFZID0gMjAgKiAxMDAwO1xuXG4vKipcbiAqIEhUVFAgc3RhdHVzIGNvZGVzIHRoYXQgaW5kaWNhdGUgdGhlIG9wZXJhdGlvbiBtYXkgYmUgcmV0cmllZC5cbiAqL1xuZXhwb3J0IGNvbnN0IFJFVFJZQUJMRV9TVEFUVVNfQ09ERVMgPSBuZXcgU2V0PG51bWJlcj4oKTtcbls0MjksIDUwMCwgNTAyLCA1MDMsIDUwNCwgNTA5XS5mb3JFYWNoKGNvZGUgPT5cbiAgUkVUUllBQkxFX1NUQVRVU19DT0RFUy5hZGQoY29kZSlcbik7XG5cbi8qKlxuICogVGhlIHJldHJ5IGRlbGF5IGJhc2UgKGluIG1pbGxpc2Vjb25kcykgdG8gdXNlIHdoZW4gYSB0aHJvdHRsaW5nIGVycm9yIGlzXG4gKiBlbmNvdW50ZXJlZC5cbiAqL1xuZXhwb3J0IGNvbnN0IFRIUk9UVExJTkdfUkVUUllfREVMQVlfQkFTRSA9IDUwMDtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/middleware-retry/build/constants.js
// module id = i7Is
// module chunks = 0